import { render, staticRenderFns } from "./EventInfoModal.vue?vue&type=template&id=e2944472&scoped=true&"
import script from "./EventInfoModal.vue?vue&type=script&lang=js&"
export * from "./EventInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./EventInfoModal.vue?vue&type=style&index=0&id=e2944472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2944472",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
